export enum DirectPaymentMethods {
  PAPARA = 'PAPARA',
  IDEAL = 'IDEAL',
  ADVCASH = 'ADVCASH',
  EPAY = 'EPAY',
  P24 = 'P24',
  PIPIT = 'PIPIT',
  PAYFIX = 'PAYFIX',
  MONEYTOLIA = 'MONEYTOLIA',
  AUTO_MONEYTOLIA = 'AUTO_MONEYTOLIA',
  PEPPARA = 'PEPPARA',
  PARAZULA = 'PARAZULA',
  MEFETE = 'MEFETE',
  INSTRA = 'INSTRA',
  INSTANT_BANK_TRANSFER = 'INSTANT_BANK_TRANSFER',
  INSTANT_CEPBANK = 'INSTANT_CEPBANK',
  MANUAL_QR = 'MANUAL_QR',
  JETON_WALLET = 'JETON_WALLET',
  WEBMONEY = 'WEBMONEY',
  PERFECTMONEY = 'PERFECTMONEY',
  BITCOIN = 'BITCOIN',
  CRYPTOPAY = 'CRYPTOPAY',
  CONVENIENT_STORE = 'CONVENIENT_STORE ',
  DIRECTPAY = 'DIRECTPAY',
  ENTERCASH = 'ENTERCASH',
  MULTIBANCO = 'MULTIBANCO',
  TWINT = 'TWINT',
  KINGDOM_PAY = 'KINGDOM_PAY',
  ECOPAYZ = 'ECOPAYZ',
  FLYCHECKOUT = 'FLYCHECKOUT',
  MONGAPAY = 'MONGAPAY',
  SWISH = 'SWISH',
  PAPARA_QR = 'PAPARA_QR',
  APP_PAY = 'APP_PAY',
  KLARNAPNS = 'KLARNAPNS',
  BANCOMATPAY = 'BANCOMATPAY',
  EPS = 'EPS',
  BANCONTACT = 'BANCONTACT',
  SOFORT = 'SOFORT',
  GIROPAY = 'GIROPAY',
  FASAPAY = 'FASAPAY',
  PAYU = 'PAYU',
  YANDEXMONEY = 'YANDEXMONEY',
  NEOSURF = 'NEOSURF',
  PAYEER = 'PAYEER',
  RAPIDTRANSFER = 'RAPIDTRANSFER',
  SKRILLWALLET = 'SKRILLWALLET',
  YANDEX = 'YANDEX',
  MWALLET_PAPARA = 'MWALLET_PAPARA',
  MWALLET_TOSLA = 'MWALLET_TOSLA',
  CCCRYPTO = 'CCCRYPTO',
  CCVOUCHER = 'CCVOUCHER',
  MWALLET_VIP = 'MWALLET_VIP',
  INDIAN_NET_BANKING = 'INDIAN_NET_BANKING',
  INTERAC = 'INTERAC',
  MWALLET_PEPPARA = 'MWALLET_PEPPARA',
  NETBANKING_IDR = 'NETBANKING_IDR',
  PAYPAYJP = 'PAYPAYJP',
  COMMUNITY_BANK = 'COMMUNITY_BANK',
  BTCRYPTO = 'BTCRYPTO',
  PPBTVOUCHER = 'PPBTVOUCHER',
  // PAGO_EFECTIVO_BT = 'PAGO_EFECTIVO_BT',
  // PAGO_EFECTIVO_CP = 'PAGO_EFECTIVO_CP',
  PAPARAC = 'PAPARAC',
  PEPPARAC = 'PEPPARAC',
  MWALLET_FUPS = 'MWALLET_FUPS',
  CHILEAN_BANK_TRANSFER = 'CHILEAN_BANK_TRANSFER',
  CHILEAN_MANUAL_BANK_TRANSFER = 'CHILEAN_MANUAL_BANK_TRANSFER',
  BTVOUCHER_ATM = 'BTVOUCHER_ATM',
  BANKY_INSTANT_BANK_TRANSFER = 'BANKY_INSTANT_BANK_TRANSFER',
  BLIK = 'BLIK',
  TRUSTLY = 'TRUSTLY',
  AUTO_PAPARA = 'AUTO_PAPARA',
  CASHTOCODE = 'CASHTOCODE',
  CASHTOVOUCHER = 'CASHTOVOUCHER',
  ANINDA_TRANSFER = 'ANINDA_TRANSFER',
}
